// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Home = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Home = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Home = _exports.Home = function Home(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M3.125 8.28157V17.5003C3.125 17.6661 3.19085 17.8251 3.30806 17.9423C3.42527 18.0595 3.58424 18.1253 3.75 18.1253H7.5V12.8128C7.5 12.5642 7.59877 12.3257 7.77459 12.1499C7.9504 11.9741 8.18886 11.8753 8.4375 11.8753H11.5625C11.8111 11.8753 12.0496 11.9741 12.2254 12.1499C12.4012 12.3257 12.5 12.5642 12.5 12.8128V18.1253H16.25C16.4158 18.1253 16.5747 18.0595 16.6919 17.9423C16.8092 17.8251 16.875 17.6661 16.875 17.5003V8.28157M18.75 10.0003L10.4254 2.03154C10.2301 1.82529 9.77344 1.82295 9.57461 2.03154L1.25 10.0003M15.625 6.99251V2.50032H13.75V5.19563",
      stroke: "currentColor",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }));
  };
});
